import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

import chevronDown from 'icons/chevron-down.svg';

export const Wrapper = styled.section`
	padding: 40px 0 80px;
	text-align: center;

	${minWidth('tablet')} {
		padding: 80px 0;
	}
`;

export const Heading = styled.h1`
	color: ${palette('blue3')};
	font-size: 28px;
	${fontWeight(FontWeights.Medium)};
	margin-bottom: 40px;

	${minWidth('tablet')} {
		font-size: 49.5px;
		${fontWeight(FontWeights.Regular)};
		margin-bottom: 80px;
	}
`;

export const FaqItems = styled.div`
	margin-bottom: 40px;
`;

export const Question = styled.div`
	color: ${palette('gray8')};
	cursor: pointer;
	font-size: 20px;
	${fontWeight(FontWeights.Medium)};
	padding: 16px 48px 16px 16px;
	position: relative;
	text-align: left;

	${minWidth('tablet')} {
		font-size: 22.5px;
		padding: 16px 48px 16px 24px;
	}

	${minWidth('desktop')} {
		&:hover {
			background: rgba(85, 91, 228, 0.1);
		}
	}
`;

export const Answer = styled.div`
	color: ${palette('gray8')};
	display: none;
	padding: 16px;
	text-align: left;

	${minWidth('tablet')} {
		padding: 16px 24px;
	}

	& a {
		color: ${palette('blue3')};
	}
`;

export const Arrow = styled(chevronDown)`
	height: 24px;
	width: 32px;
	position: absolute;
	right: 24px;
	top: 24px;

	& path {
		fill: ${palette('gray6')};
	}
`;

export const FaqItem = styled.div<{ isActive: boolean }>`
	border-radius: 8px;
	border: 1px solid ${palette('gray3')};
	margin-bottom: 8px;

	${p =>
		p.isActive &&
		`
    ${Question} {
      background: rgba(85, 91, 228, 0.1);
      border-bottom: 1px #aaa solid;
    }

    ${Answer} {
      display: block;
    }

    ${Arrow} {
      transform: rotate(180deg);
    }
  `}
`;

export const ButtonWrapper = styled.div`
	margin: 0 auto;
	width: 356px;
`;
